export enum KeyParam {
  QR_TYPE = 'tipoCodigoQR',
  SEDES = 'sedes',
  TIPO_MARCACION = 'tipoMarcacion',
}
